import type {
  AmPm,
  TimeValue,
} from "../../../../lib/utils/hallowAdminDashboard/eventForm.model";

const HOURS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] as const;
const MINUTES = [0, 15, 30, 45] as const;

/**
 * The first quarter hour strictly after `from`, so a default selection is
 * always a time that can still be picked today. Rolls into the next day near
 * midnight.
 */
export const nextQuarterHour = (from: Date): Date => {
  const next = new Date(from);
  next.setSeconds(0, 0);
  next.setMinutes(next.getMinutes() + (15 - (next.getMinutes() % 15)));
  return next;
};

/** Every 15-minute wall time in a day, ordered from 12:00 AM through 11:45 PM. */
export function allQuarterHourTimesInOrder(): TimeValue[] {
  const out: TimeValue[] = [];
  for (const amPm of ["AM", "PM"] as AmPm[]) {
    for (const hour of HOURS) {
      for (const minute of MINUTES) {
        out.push({ hour, minute, amPm });
      }
    }
  }
  return out;
}
